import API from '../../api/trips'

const store = {
  namespaced: true,
  state: () => ({
    items: [],
    item: {}
  }),
  mutations: {
    set(state, items) {
      state.items = items
    },
    show(state, item) {
      state.item = item
    }
  },
  actions: {
    async fetch(context) {
      let items = await API.list()
      items = items.map(item => {
        if (Date.parse(item.startDate) != NaN && Date.parse(item.endDate) != NaN) {
          item._days = ((new Date(item.endDate).getTime() - new Date(item.startDate).getTime()) / 1000 / 60 / 60 / 24).toFixed()
          item._startDate = item.startDate && new Date(item.startDate).toInputDateFormat()
          item._endDate = item.endDate && new Date(item.endDate).toInputDateFormat()
        }
        item._distance = item.startKm && item.endKm && item.endKm - item.startKm
        return item
      })
      context.commit('set', items)
    },
    async show(context, id) {
      const item = await API.show(id)
      context.commit('show', item)
    },
    async edit(context, { id, data }) {
      const item = await API.edit(id, data)
      context.commit('show', item)
    },
    async delete(context, id) {
      await API.delete(id)
      context.commit('show', {})
    }
  },
  getters: {
    items: state => {
      return state.items
    },
    item: state => {
      return state.item
    }
  }
}

export default store